import { useEffect, useState } from "react";
import { linkedClientId } from "../helpers/clientToRelatedPerson";
import { useServerApi } from "./userServerApi";

export const collectLinkedClientIds = (rows) => {
  const ids = new Set();
  (rows || []).forEach((row) => {
    [row?.sourceClient, row?.trustee?.sourceClient].forEach((value) => {
      const id = linkedClientId(value);
      if (id && typeof value !== "object") ids.add(String(id));
    });
  });
  return [...ids];
};

export const linkedClientRecord = (value, cache) => {
  if (!value) return null;
  if (typeof value === "object") return value;
  return cache?.[String(value)] || null;
};

export function useLinkedClients(rows) {
  const [api] = useServerApi();
  const [cache, setCache] = useState({});
  const ids = collectLinkedClientIds(rows).join(",");

  useEffect(() => {
    const missing = ids ? ids.split(",").filter((id) => id && !cache[id]) : [];
    if (!missing.length) return undefined;

    let cancelled = false;
    Promise.all(
      missing.map((id) =>
        api
          .getById({ apiEntity: "client", id })
          .then((client) => ({ id, client }))
          .catch(() => ({ id, client: null }))
      )
    ).then((results) => {
      if (cancelled) return;
      setCache((current) => {
        const next = { ...current };
        results.forEach(({ id, client }) => {
          if (client) next[id] = client;
        });
        return next;
      });
    });

    return () => {
      cancelled = true;
    };
  }, [ids]);

  return cache;
}
